<template lang="pug">
div(:style="'min-height:' + h")
  .px-0.white.detail-head.head-border
    el-row.pl-5
      el-col(:span="8")
        Breadcrumb(:data="items")
      el-col.pt-5.text-right(:span="15")
        el-button(type="primary", size="mini", @click="exportExcel") 导出
        el-button(
          v-show="head.status==5",
          type="danger",
          size="mini",
          :loading="loading",
          @click="del"
        ) 删除
        el-button(
          v-show="head.status==2",
          type="primary",
          size="mini",
          :loading="loading",
          @click="confirm"
        ) 提交OA
        el-button(type="primary", size="mini", @click="$router.go(-1)") 返回
  div(style="height: 70px")
  el-main.white.pa-3.ma-4
    el-row
      el-col(:span="20")
        div 基本信息
    el-form.mt-4(label-width="100px", size="mini")
      el-row
        el-col(:span="7")
          el-form-item(label="对账单号:")
            span {{ head.code }}
          el-form-item(label="供应商:")
            span {{ head.supplier_name }}
          el-form-item(label="采购组织:")
            span {{ head.org_name }}
          el-form-item(label="对账来源:")
            span {{ head.source == 1 ? "供应商" : "建华" }}
          el-form-item(label="OA流程ID:")
            span {{ head.approval_id }}
          <!--el-form-item(label="对账合同号:")-->
            <!--span {{head.code_ct}}-->
        el-col(:span="7")
          el-form-item(label="对账日期:")
            span {{ head.begin_date }}-{{ head.end_date }}
          el-form-item(label="联系人:")
            span {{ head.contact }}
          el-form-item(label="采购员:")
            span {{ head.buy_person_name }}
          el-form-item(label="状态:")
            span {{ this.getMBillStaDesc(head.status) }}
          <!--el-form-item(label="对账合同名称:")-->
            <!--span {{head.name_ct}}-->
        el-col(:span="7")
          el-form-item(label="对账月份:")
            span {{ head.remark }}
          el-form-item(label="联系方式:")
            span {{ head.contact_phone }}
          el-form-item(label="联系方式:")
            span {{ head.buy_person_mobile }}
          el-form-item(label="确认日期:")
            span {{ head.confirm_date }}
      el-row
        el-col(:span="21")
          el-form-item(label="备注:")
            span {{ head.note }}
    <!--el-alert.mb-5(v-if="head.status==5" :title="'驳回原因:'+head.reject_reason+'。操作时间:'+head.reject_date" type="error" :closable="false")-->
    el-row.mt-5.mb-2
      el-col(:span="20")
        div 对账单总表
    el-table(:data="[head]", style="width: 100%", size="mini")
      el-table-column(prop="classification", label="对账类别")
      el-table-column(prop="before_debt", label="期初欠款")
      el-table-column(prop="before_invoice", label="期初欠票")
      <!--el-table-column(prop="current_num" label="本期采购数量")-->
      el-table-column(prop="current_invoice", label="本期到票金额")
      el-table-column(prop="current_money", label="本期采购金额")
      el-table-column(prop="current_pay", label="本期付款")
      el-table-column(prop="after_debt", label="期末欠款")
      el-table-column(prop="after_no_invoice", label="期末未到发票")
  el-dialog.dialog(
    title="驳回原因",
    :visible.sync="dialogFormVisible",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(
      :model="form",
      ref="form",
      size="mini",
      label-width="60px",
      :rules="rules"
    )
      el-form-item(label="内容", prop="reason")
        el-input(
          v-model="form.reason",
          type="textarea",
          :autosize="{ minRows: 2, maxRows: 4 }"
        )
    .dialog-footer(slot="footer")
      el-button(size="mini", @click="dialogFormVisible = false") 取 消
      el-button(size="mini", type="primary", @click="submitForm") 确 定
</template>
<script>
import { url } from "../../../utils/config";
import axios from "axios";
export default {
  data() {
    return {
      h: "",
      head: {},
      loading: false,
      items: [
        {
          path: "/purchase/purchase_order",
          meta: {
            title: "对账单",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "详情",
          },
        },
      ],
      rules: {
        reason: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
        ],
      },
      dialogFormVisible: false,
      form: {
        reason: "",
      },
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: [Number, String],
      default: 1,
    },
  },
  methods: {
    del() {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let res = await this.$api.mon_account_statement.del(this.id);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        })
        .catch(() => {});
    },
    async confirm() {
      this.loading = true;
      let res = await this.$api.account_statement.confirm(this.id);
      this.loading = true;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    async exportExcel() {
      this.loading = true;
      await this.$api.mon_account_statement.getBlob1({ id: this.id });
      this.loading = false;
    },
    async cancel_publish() {
      this.loading = true;
      let res = await this.$api.account_statement.cancel_publish(this.id);
      this.loading = true;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let res = await this.$api.account_statement.reject({
            id: this.id,
            reason: this.form.reason,
          });
          if (res) {
            this.dialogFormVisible = false;
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        } else {
          return false;
        }
      });
    },
    async getById() {
      let res = await this.$api.mon_account_statement.getById(this.id);
      if (res) {
        this.head = res.data;
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getById();
  },
};
</script>